import { koComponent } from '../../ko-utils';
import { ContextHelpDesign } from '../../models/Gen/TrackableBaseModels';
import $api from '../../api';
import ColorPicker from '../../components/colorPicker';
import { listenToPageDirty, resolvePageDirty } from '../../utils/changeTracking';
import { listenTo } from '../../utils/events';

class AppearanceSettingsView {
    constructor(params, customParams) {
        ColorPicker();

        this.isDirty = customParams.isDirty;

        this.contextHelpDesign = customParams.contextHelpDesign;
        this.parentPage = customParams.parentPage;

        if (!this.contextHelpDesign()) {
            this.contextHelpDesign(this.createDefaultDesign());
        }

        for (const prop in this.contextHelpDesign()) {
            if (ko.isObservable(this.contextHelpDesign()[prop])) {
                this.contextHelpDesign()[prop].subscribe(() => this.updatePreview());
            }
        }

        listenToPageDirty((opt) => {
            this.isDirty(true);
        })

        listenTo('save_design', () => {
            this.save();
        });
    }

    save() {
        this.parentPage.startSubmitting();
        $api.projects.saveContextHelpDesign(
            { state: true, projectCode: auth.project.UniqueCode },
            this.contextHelpDesign().toJS(),
            () => {
                this.parentPage.stopSubmitting();
                this.parentPage.showToast('Hints appearance saved.');
                this.isDirty(false);
                resolvePageDirty();
            }
        );
    }

    createDefaultDesign() {
        return new ContextHelpDesign({
            cardBackgroundColor: '#ffffff',
            cardTextColor: '#000000',
            cardBackdropColor: '#00000066',

            skipButtonBackgroundColor: '#000000',
            skipButtonTextColor: '#ffffff',

            dividersColor: '#dfdfdf'
        });
    }

    getDesignConfig() {
        return JSON.parse(JSON.stringify(ko.toJS(this.contextHelpDesign())));
    }

    initPreview() {
        /** @type {HTMLIFrameElement} */
        const el = document.getElementById('previewer');

        el.contentWindow.postMessage({
            action: 'init',
            type: 'context-help',
            design: this.getDesignConfig()
        });
    }

    updatePreview() {
        /** @type {HTMLIFrameElement} */
        const el = document.getElementById('previewer');

        el.contentWindow.postMessage({
            action: 'update',
            type: 'context-help',
            design: this.getDesignConfig()
        });
    }
}

export default koComponent('appearance-settings', AppearanceSettingsView);